import FingerprintJS from '@fingerprintjs/fingerprintjs';

/**
 * Generate anonymous device fingerprint
 * Returns a unique visitor ID based on browser/device characteristics
 * Privacy-safe: No personal data is collected
 */
export const getDeviceFingerprint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    console.error('Error generating device fingerprint:', error);
    // Fallback: Generate a simple fingerprint based on available data
    return generateFallbackFingerprint();
  }
};

/**
 * Fallback fingerprint generation if FingerprintJS fails
 */
const generateFallbackFingerprint = () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText('FingerprintJS', 2, 2);
  
  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    window.screen.width + 'x' + window.screen.height,
    new Date().getTimezoneOffset(),
    canvas.toDataURL()
  ].join('|');
  
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return Math.abs(hash).toString(36);
};
